<template>
    <div>
        <v-card>
            <s-toolbar label="Aprobacion de Asistencia Remota" dark color="#8e8f91" searchInput @textSearch="textSearch($event)" >
                <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            text
                            black
                            small
                            @click="approve(1)"
                            v-if="$fun.isAdmin()"
                        > 
                            <v-icon>mdi-thumb-up</v-icon>
                        </v-btn>
                    </template>
                    <span>Aprobar</span>
                </v-tooltip>
                <!-- <v-tooltip bottom="">
                    <template v-slot:activator="{ on }">
                        <v-btn 
                            v-on="on"
                            text
                            black
                            small
                            @click="approve(2)"
                            v-if="$fun.isAdmin()"
                        >
                            <v-icon>mdi-thumb-down</v-icon>
                        </v-btn>
                    </template>
                    <span>Desaprobar</span>
                </v-tooltip> -->
            </s-toolbar>
            <v-container>
				<!-- <v-row>
                    <v-col cols="12" md="4">
                        <s-select-area 
                            label="Area"
                            v-model="filter.AreID"
                            noDefault
                            full
                        />
                    </v-col>
                </v-row> -->
                <v-row>
                    <v-col>
                        <v-data-table
                            item-key="RtwID"
                            dense
                            fixed-header
                            :items="items"
                            :headers="config.headers"
                            :items-per-page="10"
                            v-model="selected"
                            @click:row="rowClick"
                        >
                            <template v-slot:[`item.RtwDate`]="{ item }">
                                {{ $fun.formatDateView(item.RtwDate) }}
                            </template>
                            <template v-slot:[`item.TdrDateBegin`]="{ item }">
                                {{ $fun.formatDateTimeView(item.TdrDateBegin) }}
                            </template>
                            <template v-slot:[`item.TdrDateEnd`]="{ item }">
                                {{ $fun.formatDateTimeView(item.TdrDateEnd) }}
                            </template>
                            <template v-slot:[`item.TdrStatus`]="{ item }">
                                <v-chip
                                    x-small
                                    :color="getColor(item.RtwApproved)"
                                    dark
                                >
                                    {{ getText(item.RtwApproved) }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.Actions`]="{ item }">
                                <v-btn
                                    small
                                    color="purple-darken-4"
                                    class="mb-1"
                                    @click="openTasksDialog(item)"
                                    icon
                                >
                                    <v-icon>mdi-file-star-four-points-outline</v-icon>
                                </v-btn>

                                <v-btn
                                    icon
                                    small
                                    color="cyan darken-4" 
                                    dark
                                    class="mb-1"
                                    @click="editRemoteWorkDialog(item)"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>

                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-dialog persistent v-if="openDialog" v-model="openDialog" max-width="600px">
            <s-Tasks :item="newData" @close="close"></s-Tasks>
        </v-dialog>

        <v-dialog v-model="showEditMarking" v-if="showEditMarking" persistent max-width="900">
            <v-card>
                <div style="padding: 16px 24px 10px">
                    <s-crud
                        height="auto"
                        title="Marcaciones de Trabajo Remoto"
                        :config="configAttendance"
                        :filter="filterAttendance"
                        searchInput
                        close
                        @close="closeEditMarking()"
                    >
                    <template v-slot:TdrStatusMarking="{ row }">
                        <v-chip x-small :color="row.MrkID === null ? 'orange' : 'green'" dark>{{ row.MrkID === null ? 'Por aprobar' : 'Aprobado' }}</v-chip>
                    </template>
                    </s-crud>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
    import _sAttendanceRemoteService from '@/services/HumanResource/Compensation/HmnAttendanceRemoteService.js';
    import _RemoteWorkService from "@/services/HumanResource/Compensation/HmnRemoteWorkService";
    import _sMassiveAssistanceGangService from "@/services/HumanResource/Compensation/HmnMassiveAssistanceGangService";
    import sTasks from '@/components/Utils/RecursosHm/sTasks.vue';
    
    export default {
        components: {
            sTasks
        },
        data() {
            return {
                filter:{
                    UsrID: 0,
                },
                filterAttendance: {
                    RtwID: 0
                },
                items: [],
                selected: [],
                openDialog: false,
                newData: {},
                showEditMarking: false,
                itemApproval: {},
                searchText: "",
                listMarking: {},
                config: {
                    headers: [
                        {text: "ID"									, value: "RtwID"				},
                        {text: "N° Doc"								, value: "PrsDocumentNumber"	},
                        {text: "Nombres y Apellidos Completos"		, value: "NtpFullName"			},
                        {text: "Descripcion"		                , value: "RtwDescription"		},
                        {text: "Area"								, value: "AreName"				},
                        {text: "Fecha de programación"			    , value: "RtwDate"			    },
                        {text: "Fecha Entrada Inicial"			    , value: "TdrDateBegin"		    },
                        {text: "Fecha Salida Final"			        , value: "TdrDateEnd"		    },
                        {text: "Estado"			                    , value: "TdrStatus"		    },
                        {text: "Acciones"			                , value: "Actions"			    },
                    ],
                },
                configAttendance: {
                    service: _sAttendanceRemoteService,
                    model: {
                        TdrID: "ID",
                        TdrDateMarking: "datetime",
                    },
                    headers: [
                        {text: "ID"									, value: "TdrID"				},
                        {text: "N° Doc"								, value: "PrsDocumentNumber"	},
                        {text: "Nombres y Apellidos Completos"		, value: "NtpFullName"			},
                        {text: "Tipo Marcación"			            , value: "TdrTypeAttendanceName"},
                        {text: "Asistencia"			                , value: "TdrDateMarking"		},
                        {text: "Observacion"			            , value: "TdrObservation"		},
                        {text: "Estado"			                    , value: "TdrStatusMarking"		},
                    ],
                },
            }
        },
        methods:{
            load() {
                _sAttendanceRemoteService
                    .listApproval(this.filter, this.$fun.getUserID())
                    .then((r) => {
                        this.items = r.data;
                    });
            },
            rowClick: function(item, row) {
				if (item !== undefined) {
					this.selected = [item];
				}
			},
            openTasksDialog(item) {
                this.newData = {};
                this.newData.RtwID = item.RtwID;
                this.openDialog = true;
            },
            close() {
                this.openDialog = false;
                this.newData = {};
            },
            editRemoteWorkDialog(item) {
                this.editRemoteWork = {};
                this.editRemoteWork = item;
                this.filterAttendance.RtwID = item.RtwID;
                this.showEditMarking = true;
            },
            closeEditMarking() {
                this.showEditMarking = false;
                this.editRemoteWork = {};
            },
            
            async approve(state) {

                if(this.selected.length == 0) return this.$fun.alert("No selecciono ningun registro", "warning");
                //console.log(this.selected[0]);
                this.itemApproval = this.selected[0];

                const confirm = await this.$fun.alert("¿Seguro de Guardar?", "question");
                if (!confirm.value) return;

                if (state == 1) {
                    try {
                        const resp = await _sAttendanceRemoteService.listMarking(this.itemApproval, this.$fun.getUserID());
                        this.listMarking = resp.data;
                        //console.log("listMarking", this.listMarking);

                        const saveResults = [];

                        for (const item of this.listMarking) {
                            const newItem = {
                                ...item,
                                MrkType: 2, // Asistencia Remota
                                MrkObservation: "Asistencia Remota",
                                MrkMarking: item.TdrDateMarking,
                                MrkTypeStatusMarking: item.TdrTypeMarking,
                                MrkObservation: item.TdrObservation,
                                UsrCreateID: this.$fun.getUserID(),
                                UsrID: this.$fun.getUserID()
                            };

                            try {
                                const response = await _sMassiveAssistanceGangService.save([newItem], this.$fun.getUserID());
                                const savedItem = response.data[0];
                                newItem.MrkID = savedItem.MrkID;
                                saveResults.push({ item: newItem, success: response.status == 200, response });
                                
                            } catch (error) {
                                saveResults.push({ item: newItem, success: false, error });
                                return;
                            }
                        }

                        //console.log("saveResults", saveResults);

                        // Recorrer los ítems exitosos y guardarlos nuevamente con otro servicio
                        for (const result of saveResults) {
                            if (result.success) {
                                const item = result.item;

                                try {
                                    const saveResp = await _sAttendanceRemoteService.save(item, this.$fun.getUserID());
                                    //console.log("Guardado en AttendanceRemote:", saveResp.data);
                                } catch (error) {
                                    console.error("Error al guardar en AttendanceRemote:", item, error);
                                }
                            }
                        }

                        // Validar si todos fueron exitosos
                        const allSuccess = saveResults.every(r => r.success);

                        if (allSuccess) {
                            this.itemApproval.RtwApproved = state;
                            const saveResp = await _RemoteWorkService.save(this.itemApproval, this.$fun.getUserID());
                            if (saveResp.status == 200) {
                                this.$fun.alert("Se agregó correctamente", "success");
                                this.load();
                            } else {
                                this.$fun.alert("Error al actualizar el estado", "error");
                            }
                        } else {
                            this.$fun.alert("Algunos registros no se pudieron guardar", "warning");
                        }
                    } catch (error) {
                        this.$fun.alert("Error al obtener marcaciones", "warning");
                    }
                } else {
                    try {
                        this.itemApproval.RtwApproved = state;
                        const resp = await _RemoteWorkService.save(this.itemApproval, this.$fun.getUserID());
                        if (resp.status == 200) {
                            this.$fun.alert("Se agregó correctamente", "success");
                            this.load();
                        } else {
                            this.$fun.alert("Error al actualizar el estado", "warning");
                        }
                    } catch (error) {
                        this.$fun.alert("Error al actualizar el estado", "warning");
                    }
                }
            },
            getText(RtwApproved) {
                if (RtwApproved === null) {
                return 'Por aprobación.'
                } else if (RtwApproved === 1) {
                return 'Aprobado.'
                } else if (RtwApproved === 2) {
                return 'Desaprobado.'
                }
            },
            getColor(RtwApproved) {
                if (RtwApproved === null) {
                return 'grey'
                } else if (RtwApproved === 1) {
                return 'green'
                } else if (RtwApproved === 2) {
                return 'red'
                }
            },
            textSearch(text){
                this.filter.Search = text;
                this.load();
            },
        },

        created() {
            this.filter.UsrID =  this.$fun.getUserID() ?? 0;
            this.load();
        },
        watch: {
            "filter.UsrID"() {
                this.load();
            },
        },
    }
  </script>
  